export const i18n = {
  defaultLocale: "nl",
  locales: ["en", "nl"],
  langDirection: {
    en: "ltr",
    nl: "ltr",
  },
} as const;

export type Locale = (typeof i18n)["locales"][number];
